// extracted by mini-css-extract-plugin
export default {"pdfLogo":"studentprofile_pdfLogo__KDmyg"};